<p-dialog header="{{title}}" [(visible)]="display" [responsive]="true" showEffect="fade" [modal]="true" *ngIf="display" appendTo="body">

    <!-- #region BODY -->
    <div class="container-md">

        <!-- COMPANY & DELEGATION-->
        <div class="row justify-content-start mt-3">
            <div class="col d-flex flex-row align-items-center">
                <label for="fine-name" class="custom-label" i18n>
                    {{ 'tableManagement.companies.company' | translate }}
                </label>
                <div class="p-3"></div>
                <p-dropdown
                    [options]="billingAccountList"
                    [(ngModel)]="entity.company"
                    placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.companies.company' | translate }}"
                    dataKey="id"
                    optionLabel="fullName"
                    [style]="{ width: '250px' }"
                    appendTo="body"
                    [filter]="true"
                    (onChange)="onChangeBillingAccount($event)"
                    (onFilter)="onFilterBillingAccount($event)"                  
                >
                </p-dropdown>
            </div>

            <div class="col d-flex flex-row align-items-center">
                <label for="fine-name" class="custom-label" i18n>
                    {{ 'tableManagement.delegations.delegation' | translate }}
                </label>
                <div class="p-3"></div>
                <p-dropdown
                    [options]="delegationList"
                    [(ngModel)]="entity.delegation"
                    placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.delegations.delegation' | translate }}"
                    dataKey="id"
                    [style]="{ width: '250px' }"
                    appendTo="body"
                    optionLabel="fullName"
                    [filter]="true"
                    (onChange)="onChangeDelegation($event)"
                    (onFilter)="onFilterDelegation($event)"                  
                >
                </p-dropdown>
            </div>
        </div>

        <!-- SUBDELEGATION & CECO-->
        <div class="row justify-content-start mt-3">
            <div class="col d-flex flex-row align-items-center">
                <label for="fine-name" class="custom-label" i18n>
                    {{ 'tableManagement.subdelegations.subdelegation' | translate }}
                </label>
                <div class="p-3"></div>
                <p-dropdown
                    [options]="subDelegationList"
                    [(ngModel)]="entity.subDelegation"
                    placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.subdelegations.subdelegation' | translate }}"
                    dataKey="id"
                    [style]="{ width: '250px' }"
                    appendTo="body"
                    [filter]="true"
                    optionLabel="fullName"
                    (onChange)="onChangeSubDelegation($event)"
                    (onFilter)="onFilterSubDelegation($event)"                  
                >
                </p-dropdown>
            </div>

            <div class="col d-flex flex-row align-items-center">
                <label for="fine-name" class="custom-label" i18n>
                    {{ 'drivers.table.ceco' | translate }}
                </label>
                <div class="p-3"></div>
                <p-dropdown
                    [options]="cecoList"
                    [(ngModel)]="entity.ceco"
                    placeholder="{{ 'general.select' | translate }} {{ 'drivers.table.ceco' | translate }}"
                    dataKey="id"
                    [style]="{ width: '250px' }"
                    appendTo="body"
                    [filter]="true"
                    optionLabel="fullName"
                    (onChange)="onChangeCeco($event)"
                    (onFilter)="onFilterCeco($event)"                  
                >
                </p-dropdown>
            </div>
        </div>
        <!-- START DATE & END DATE -->
        <div class="row justify-content-start mt-3">
            <div class="col d-flex flex-row align-items-center">
                <label for="fine-name" class="custom-label" i18n>
					<strong>{{ 'tableManagement.cardLists.assignDateShort' | translate }} (*)</strong>
                </label>
                <div class="p-3"></div>
                <p-calendar [(ngModel)]='startDate' [showTime]='false' [style]="{'width':'200px'}"
                    dateFormat='{{i18n.dateFormat}}' showIcon='true' appendTo='body' [firstDayOfWeek]="1" [minDate]="minStartDate" 
                    [maxDate]="maxStartDate" ></p-calendar>
            </div>

            <div class="col d-flex flex-row align-items-center">
                <label for="fine-name" class="custom-label" i18n>
					{{ 'tableManagement.cardLists.deassignDateShort' | translate }}
                </label>
                <div class="p-3"></div>
                <p-calendar [(ngModel)]='endDate' [showTime]='false' [style]="{'width':'200px'}"
                    dateFormat='{{i18n.dateFormat}}' showIcon='true' appendTo='body' [firstDayOfWeek]="1"></p-calendar>
            </div>
        </div>

    </div>
    <!-- #endregion BODY -->

    <!-- #region FOOTER -->
    <p-footer>
        <div class="d-flex justify-content-center bd-highlight">
            <div class="p-2 bd-highlight">
                <div *ngIf="!isNew">
                    <button class="btn custom-button" (click)="save()" [disabled]="!canUpdate" i18n>
                        {{'general.save' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </p-footer>
    <!-- #endregion FOOTER -->

</p-dialog>